import { Component } from '@angular/core';

@Component({
  selector: 'app-merchant',
  templateUrl: './merchant.component.html',
  styleUrls: ['./merchant.component.css'],
})
export class MerchantComponent {
  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-building-columns',
      bgClass: 'bg-white',
      desc: 'Banks',
      route: '/numbers',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Merchant',
      route: '/numbers/finance/stripe',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'Analysis',
      route: '/numbers/finance/analysis',
    },
  ];
}
